import template from './application_list.html.slim';
import controller from './application_list_controller.js';

angular.module('wbComponents').directive('applicationList', () => ({
  restrict: 'E',
  replace: true,
  controller,
  templateUrl: template,
  controllerAs: 'ctrl',
}));
